import React from 'react';
import './InconsistenciesModal.css';

const InconsistenciesModal = ({show, handleClose, inconsistencies}) => {
    if (!show) return null;

    const handleRowClick = (item) => {
        // Store the selected item into sessionStorage.
        sessionStorage.setItem("orderState", JSON.stringify({items: [item]}));
        // Open the Order page in a new tab.
        window.open(`${window.location.origin}/order`, '_blank');
    };

    return (
        <div className="icm-overlay">
            <div className="icm-modal">
                <div className="icm-header">
                    <h2 className="icm-title">Material Inconsistencies Detected</h2>
                </div>
                <div className="icm-body">
                    {Object.keys(inconsistencies).length === 0 ? (
                        <div className="icm-no-data">
                            <p>No material inconsistencies were found in your cart.</p>
                        </div>
                    ) : (
                        Object.entries(inconsistencies).map(([property, data]) => (
                            <div key={property} className="icm-section">
                                <div className="icm-section-header">
                                    <h3>{property === 'caseMaterial' ? 'Case Material' : 'Front Material'}</h3>
                                </div>
                                <div className="icm-section-body">
                                    <div className="icm-majority">
                                        <p>
                                            <strong>Majority:</strong> {data.majorityCount} out of {data.total} items
                                            have{' '}
                                            <span className="icm-majority-value">"{data.majorityValue}"</span>
                                        </p>
                                    </div>
                                    <div className="icm-minority">
                                        <p>
                                            <strong>Inconsistent Items:</strong>
                                        </p>
                                        <div className="icm-table-container">
                                            <table className="icm-table">
                                                <thead>
                                                <tr>
                                                    <th>Position Name</th>
                                                    <th>Material</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {data.minorityItems.map((item) => (
                                                    <tr
                                                        key={item.itemId}
                                                        className="icm-clickable-row"
                                                        onClick={() => handleRowClick(item)}
                                                    >
                                                        <td>{item.positionName || 'N/A'}</td>
                                                        <td>{item[property]}</td>
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
                <div className="icm-footer">
                    <button id="icm-close-button" className="btn btn-secondary" onClick={handleClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default InconsistenciesModal;
